import React from 'react';
import { Redirect } from 'react-router';

import { textWrap } from 'Core/Utils';
import PublicStore from 'Site/State/Store';
import { getPost } from 'Site/State/Actions';
import PageController from 'Site/Controllers/PageController';

class PostController extends React.Component {
  constructor (props) {
    super(props);
    const { blogId, postId } = props;
    this.state = { post: getPost(blogId, postId) };

    this.componentDidMount = this.componentDidMount.bind(this)
    this.componentWillUnmount = this.componentWillUnmount.bind(this);
  }

  componentDidMount () {
    this.unsubscribe = PublicStore.subscribe(() => {
      const { blogId, postId } = props;
      this.setState({ post: getPost(blogId, postId) });
    });
  }

  componentWillUnmount () {
    this.unsubscribe();
  }

  getContentSections ({ image = {}, title, content, slug }, blogId) {
    return [
      {
        type: 'Hero',
        fullWidth: true,
        props: {
          title: textWrap(title),
          background: { image: image.url, position: image.position }
        }
      },
      {
        type: 'Article',
        props: { content }
      },
      {
        type: 'RecentBlogPosts',
        props: {
          id: blogId,
          limit: 2,
          activePostSlug: slug
        }
      }
    ];
  }

  render () {
    const { blogId } = this.props;
    const { post } = this.state;
    if (!post) return (<Redirect to="/404" />);
    const content = this.getContentSections(post, blogId);
    return (<PageController content={content} />);
  }
};

export default PostController;



// WEBPACK FOOTER //
// ./client/Site/Controllers/PostController.jsx